module.exports = __webpack_public_path__ + "static/media/Illustration-Magic.58d28744.svg";